import { useMemo } from 'react';
import { ZanbatoClosedTransaction, ZanbatoPricingItem } from 'api';
import { buildPreviewRows } from './SecondaryTransactionsPreviewModal.utils';

/**
 * Headless hook to isolate data transformation from presentation UI.
 */
export const useSecondaryTransactionsPreview = (
  pricing: ZanbatoPricingItem[],
  transactions: ZanbatoClosedTransaction[],
  measurementDate: string
) => useMemo(
  () => buildPreviewRows(pricing, transactions, measurementDate),
  [pricing, transactions, measurementDate]
);
